enum ChessPiece{
    KING,QUEEN,BISHOP,KNIGHT,ROOK,PAWN,PAWN_PASSE
}
enum PieceColor{
    WHITE,BLACK
}
/// screenshot an b.kuhstoss@web.de
class ChessField{
    board: ChessBoard;
    x : number;
    y : number;
    piece: ChessPiece | null;
    color: PieceColor;

    constructor(board: ChessBoard, x: number, y: number, piece: ChessPiece | null, color: PieceColor){
        this.board = board;
        this.x = x;
        this.y = y;
        this.piece = piece;
        this.color = color;
    }

    public canMoveTo(color : PieceColor){
        return (this.piece==null||color!=this.color)
    }

    public fieldsToMoveTo(){
        let fieldsToMoveTo = new Set<ChessField>();
        switch(this.piece){
            case ChessPiece.KING:
                this.royalMoves(fieldsToMoveTo, true)
                break;
            case ChessPiece.QUEEN:
                this.royalMoves(fieldsToMoveTo, false)
                break;
            case ChessPiece.BISHOP:
                this.bishopMoves(fieldsToMoveTo);
                break;
            case ChessPiece.ROOK:
                this.rookMoves(fieldsToMoveTo);
                break;
            case ChessPiece.KNIGHT:
                this.knightMoves(fieldsToMoveTo);
            case ChessPiece.PAWN:
            case ChessPiece.PAWN_PASSE:
                this.pawnMoves(fieldsToMoveTo);
            default:
                break;
        }
        return fieldsToMoveTo;
    }

    private addField(board: ChessBoard, field: ChessField | null, set: Set<ChessField>){
        if(field!=null&&field.canMoveTo(board.turn)){
            set.add(field);
        }
    }

    public pawnMoves(fieldsToMoveTo: Set<ChessField>){
        if((this.board.turn==PieceColor.WHITE&&this.y>0)||(this.board.turn==PieceColor.BLACK&&this.y<7)){
            let field = this.getField(this.board.time, this.board.multiverse, this.x, this.y+(this.board.turn==PieceColor.WHITE?-1:1));
            if(field!=null&&field.piece==null){
                this.addField(this.board, field, fieldsToMoveTo);
                if(field!=null&&field.piece==null&&(this.board.turn==PieceColor.WHITE&&this.y==6||this.board.turn==PieceColor.BLACK&&this.y==1)){
                    field = this.getField(this.board.time, this.board.multiverse, this.x, this.y+(this.board.turn==PieceColor.WHITE?-2:2));
                    if(field!=null&&field.piece==null){
                        this.addField(this.board, field, fieldsToMoveTo);
                    }
                }
            }
        }
        let f2 = [-1,0,1]
        f2.forEach(dx => {
            f2.forEach(dt => {
                if(Math.abs(dx)+Math.abs(dt)>0){
                    if((this.board.time+dt*2)<0||((this.board.time+dt*2)>timeline.length-1)) return;
                    timeline[this.board.time+dt*2].forEach(m => {
                        if(m==null)return;
                        let field = this.getField(this.board.time+dt*2, m.multiverse, this.x+dx, this.y+(this.board.turn==PieceColor.WHITE?-1:1));
                        if(field!=null&&field.color!=this.board.turn&&field.piece!=null){
                            fieldsToMoveTo.add(field);
                        }
                    });
                }
            });
        });
        if((this.board.turn==PieceColor.WHITE&&this.y==3)||(this.board.turn==PieceColor.BLACK&&this.y==4)){
            f2.forEach(dx => {
                f2.forEach(dt => {
                    if((this.board.time+dt*2)<0||((this.board.time+dt*2)>timeline.length-1)) return;
                        timeline[this.board.time+dt*2].forEach(m => {
                            if(m==null)return;
                            let field = this.getField(this.board.time+dt*2, m.multiverse, this.x+dx, this.y);
                            console.log(field);
                            if(field!=null&&field.color!=this.board.turn&&field.piece==ChessPiece.PAWN_PASSE){
                                console.log("passe");
                                field = this.getField(this.board.time+dt*2, m.multiverse, this.x+dx, this.y+(this.board.turn==PieceColor.WHITE?-1:1));
                                if(field!=null&&field.piece==null)
                                    fieldsToMoveTo.add(field);
                            }
                        });
                }); 
            });
        }
    }

    public knightMoves(fieldsToMoveTo: Set<ChessField>){
        let f = [-1,0,1]
        f.forEach(dx => {
            f.forEach(dy => {
                f.forEach(dt => {
                    if(dt==0&&Math.abs(dx)+Math.abs(dy)==2){
                        let field = this.getField(this.board.time, this.board.multiverse, this.x+dx*2, this.y+dy);
                        this.addField(this.board, field, fieldsToMoveTo);
                        field = this.getField(this.board.time, this.board.multiverse, this.x+dx, this.y+dy*2);
                        this.addField(this.board, field, fieldsToMoveTo);
                    }
                    else if(dy==0&&Math.abs(dt)+Math.abs(dx)==2){
                        let field = this.getField(this.board.time+dt*2, this.board.multiverse, this.x+dx*2, this.y);
                        this.addField(this.board, field, fieldsToMoveTo);
                        field = this.getField(this.board.time+dt*4, this.board.multiverse, this.x+dx, this.y);
                        this.addField(this.board, field, fieldsToMoveTo);
                    }
                    else if(dx==0&&Math.abs(dt)+Math.abs(dy)==2){
                        let field = this.getField(this.board.time+dt*2, this.board.multiverse, this.x, this.y+dy*2);
                        this.addField(this.board, field, fieldsToMoveTo);
                        field = this.getField(this.board.time+dt*4, this.board.multiverse, this.x, this.y+dy);
                        this.addField(this.board, field, fieldsToMoveTo);
                    }
                    else if(Math.abs(dx)+Math.abs(dy)+Math.abs(dt)==1){
                        if((this.board.time+dt*2)<0||((this.board.time+dt*2)>timeline.length-1)) return;
                        timeline[this.board.time+dt*2].forEach(m => {
                            if(m==null)return;
                            if(m.multiverse==this.board.multiverse){
                                return;
                            }
                            let field = this.getField(this.board.time+dt*2, m.multiverse, this.x+dx, this.y+dy);
                            this.addField(this.board, field, fieldsToMoveTo);
                        });
                        if((this.board.time+dt*4)<0||((this.board.time+dt*4)>timeline.length-1)) return;
                        timeline[this.board.time+dt*4].forEach(m => {
                            if(m==null)return;
                            if(m.multiverse==this.board.multiverse)return;
                            let field = this.getField(this.board.time+dt*4, m.multiverse, this.x+dx*2, this.y+dy*2);
                            this.addField(this.board, field, fieldsToMoveTo);
                        });
                    }
                });
            });
        });
    }

    public royalMoves(fieldsToMoveTo : Set<ChessField>, short: boolean){
        let f = [-1,0,1]
        f.forEach(dx => {
            f.forEach(dy => {
                f.forEach(dt => {
                    if(Math.abs(dx)+Math.abs(dy)+Math.abs(dt)==0)return;
                    if((this.board.time+dt*2)<0||((this.board.time+dt*2)>timeline.length-1)) return;
                    timeline[this.board.time+dt*2].forEach(m => {
                        if(m==null)return;
                        let dt2 = dt;
                        let dx2 = dx;
                        let dy2 = dy;
                        let field = this.getField(this.board.time+dt2*2, m.multiverse, this.x+dx2, this.y+dy2);
                        while(field!=null&&field.canMoveTo(this.board.turn)){
                            fieldsToMoveTo.add(field);
                            dt2 += dt;
                            dx2 += dx;
                            dy2 += dy;
                            field = this.getField(this.board.time+dt2*2, m.multiverse, this.x+dx2, this.y+dy2);
                            if(field!=null&&field.piece!=null){
                                if(field.canMoveTo(this.board.turn))fieldsToMoveTo.add(field);
                                break;
                            }
                            if(short)break;
                        }
                    });
                });
            });
        });
        for(let m = 0;m<timeline[this.board.time].length;m++){
            if(m==this.board.multiverse)continue;
            let field = this.getField(this.board.time, m, this.x, this.y);
            if(field!=null&&field.canMoveTo(this.board.turn)){
                fieldsToMoveTo.add(field);
            }
        }
    }
    public rookMoves(fieldsToMoveTo : Set<ChessField>){
        let f2 = [-1,0,1]
        f2.forEach(dx => {
            f2.forEach(dy => {
                f2.forEach(dt => {
                    if(Math.abs(dx)+Math.abs(dy)+Math.abs(dt)==1){
                        let dt2 = dt;
                        let dx2 = dx;
                        let dy2 = dy;
                        let field = this.getField(this.board.time+dt2*2, this.board.multiverse, this.x+dx2, this.y+dy2);
                        while(field!=null&&field.canMoveTo(this.board.turn)){
                            fieldsToMoveTo.add(field);
                            dt2 += dt;
                            dx2 += dx;
                            dy2 += dy;
                            field = this.getField(this.board.time+dt2*2, this.board.multiverse, this.x+dx2, this.y+dy2);
                            if(field!=null&&field.piece!=null){
                                if(field.canMoveTo(this.board.turn))fieldsToMoveTo.add(field);
                                break;
                            }
                        }
                    }
                });
            });
        });
        for(let m = 0;m<timeline[this.board.time].length;m++){
            if(m==this.board.multiverse)continue;
            let field = this.getField(this.board.time, m, this.x, this.y);
            if(field!=null&&field.canMoveTo(this.board.turn)){
                fieldsToMoveTo.add(field);
            }
        }
    }
    public bishopMoves(fieldsToMoveTo : Set<ChessField>){
        let f2 = [-1,0,1]
        f2.forEach(dx => {
            f2.forEach(dy => {
                f2.forEach(dt => {
                    if(Math.abs(dx)+Math.abs(dy)+Math.abs(dt)==2){
                        let dt2 = dt;
                        let dx2 = dx;
                        let dy2 = dy;
                        let field = this.getField(this.board.time+dt2*2, this.board.multiverse, this.x+dx2, this.y+dy2);
                        while(field!=null&&field.canMoveTo(this.board.turn)){
                            fieldsToMoveTo.add(field);
                            dt2 += dt;
                            dx2 += dx;
                            dy2 += dy;
                            field = this.getField(this.board.time+dt2*2, this.board.multiverse, this.x+dx2, this.y+dy2);
                            if(field!=null&&field.piece!=null){
                                if(field.canMoveTo(this.board.turn))fieldsToMoveTo.add(field);
                                break;
                            }
                        }
                    }
                    else if(Math.abs(dx)+Math.abs(dy)+Math.abs(dt)==1&&this.board.time+dt<timeline.length&&this.board.time+dt>=0){
                        for(let m = 0;m<timeline[this.board.time+dt].length;m++){
                            if(m==this.board.multiverse)continue;
                            let field = this.getField(this.board.time+dt*2, m, this.x+dx, this.y+dy);
                            if(field!=null&&field.canMoveTo(this.board.turn)){
                                fieldsToMoveTo.add(field);
                            }
                        }
                    }
                });
            });
        });
    }

    public click(){
        if(selectedField==this){
            selectedField = null;
            fieldsToMoveTo = new Set<ChessField>();
        }      
        else if(this.piece!=null&&this.color==this.board.turn&&this.board.nextBoards.size==0){
            selectedField = this;
            fieldsToMoveTo = this.fieldsToMoveTo();
        }
        else if(fieldsToMoveTo.has(this)&&selectedField!=null){
            this.makeMove(selectedField as ChessField, this);
            selectedField = null;
            fieldsToMoveTo = new Set<ChessField>();
        }
        else{
            selectedField = null;
            fieldsToMoveTo = new Set<ChessField>();
        }
        drawBoards();
    }

    public makeMove(from : ChessField, to : ChessField){
        let board = addBoard(to.board);
        if(from.board!=to.board){
            addBoard(from.board).fields[from.x][from.y].piece = null;
        }
        else{
            board.fields[from.x][from.y].piece = null;
        }
        if(from.piece==ChessPiece.PAWN&&Math.abs(to.y-from.y)==2){
            board.fields[to.x][to.y].piece = ChessPiece.PAWN_PASSE;
            console.log("test");
        }
        let field = this.getField(to.board.time, to.board.multiverse, to.x, to.y+(from.board.turn==PieceColor.WHITE?1:-1));
        if(from.piece==ChessPiece.PAWN&&field!=null&&field.color!=from.color&&field.piece==ChessPiece.PAWN_PASSE){
            field.board.fields[field.x][field.y].piece = null;
        }
        else{
            board.fields[to.x][to.y].piece = from.piece;
        }
        board.fields[to.x][to.y].color = from.color;
    }

    public getField(time: number, multiverse: number, x: number, y: number){
        if((time)<0||((time)>timeline.length-1)) return null;
        if((x)<0||(x>7))return null;
        if((y)<0||(y>7))return null;
        if(multiverse>timeline[time].length-1||multiverse<0)return null;
        return timeline[time][multiverse]==null?null:timeline[time][multiverse]!.fields[x][y];
    }
}
class ChessBoard{

    previousBoard: ChessBoard | null;
    nextBoards: Set<ChessBoard>;
    canvas: HTMLCanvasElement;
    context: CanvasRenderingContext2D;
    fields: ChessField[][];
    time: number;
    turn: PieceColor;
    multiverse: number;

    constructor(canvas: HTMLCanvasElement, previousBoard: ChessBoard | null, multiverse: number){
        this.previousBoard = previousBoard;
        this.turn = PieceColor.WHITE;
        if(previousBoard!=null){previousBoard.nextBoards.add(this);this.turn = previousBoard.turn==PieceColor.WHITE?PieceColor.BLACK:PieceColor.WHITE;}
        this.nextBoards = new Set<ChessBoard>();
        this.fields = [];

        for(let i = 0;i<8;i++){
            let f = [];
            for(let j = 0;j<8;j++){
                f.push(new ChessField(this, i, j, null, PieceColor.WHITE));
            }
            this.fields.push(f);
        }
        if(previousBoard!=null){
            for(let i = 0;i<8;i++){
                for(let j = 0;j<8;j++){
                    this.fields[i][j].piece = previousBoard.fields[i][j].piece;
                    if(this.fields[i][j].piece==ChessPiece.PAWN_PASSE)this.fields[i][j].piece = ChessPiece.PAWN;
                    this.fields[i][j].color = previousBoard.fields[i][j].color;
                }
            }
        }
        this.canvas = canvas;
        this.canvas.width = CHESSBOARD_SIZE;
        this.canvas.height = CHESSBOARD_SIZE;
        this.canvas.addEventListener("click", e => {
            let x = Math.floor(8*e.offsetX/this.canvas.width);
            let y = Math.floor(8*e.offsetY/this.canvas.height);
            this.fields[x][y].click();
        });
        this.context = this.canvas.getContext("2d")!;
        this.time = previousBoard==null?0:previousBoard.time+1;
        this.multiverse = multiverse;
    }

    public drawBoard() {
        let w = this.canvas.width/8;
        let h = this.canvas.height/8;
        for(let i = 0;i<8;i++){
            for(let j = 0;j<8;j++){
                let b = (i%2^j%2);
                if(selectedField==this.fields[i][j])
                    this.context.fillStyle = "hsl(30,70%,40%)";
                else if(fieldsToMoveTo.has(this.fields[i][j]))
                    this.context.fillStyle = "hsl(50,80%,50%)";
                else if(b==0)
                    this.context.fillStyle = "#94b840";
                else 
                    this.context.fillStyle = "#2e3b10";
                this.context.fillRect(i*w,j*h,w,h); 
                let field = this.fields[i][j];
                if(field.piece != null){
                    this.context.drawImage(pieceImages[(field.piece==ChessPiece.PAWN_PASSE?ChessPiece.PAWN:field.piece)+"_"+field.color], i*w,j*h,w,h);
                }               
            }
        }
        if(this.nextBoards.size>0){
            this.context.fillStyle = this.turn==PieceColor.WHITE?"rgba(220,220,220,40%)":"rgba(50,50,50,40%)";
            this.context.fillRect(0,0,this.canvas.width, this.canvas.height); 
        }
    }
}
const CHESSBOARD_SIZE = 300;

function defaultStartBoardFields(board : ChessBoard){
    var order = [ChessPiece.ROOK, ChessPiece.KNIGHT, ChessPiece.BISHOP, ChessPiece.QUEEN, ChessPiece.KING,ChessPiece.BISHOP,ChessPiece.KNIGHT,ChessPiece.ROOK];

    for(let i = 0;i<8;i++){
        for(let j = 0;j<8;j++){
            board.fields[i][j].piece = null;
            board.fields[i][j].color = j>3?PieceColor.WHITE:PieceColor.BLACK;
        }
        board.fields[i][0].piece = order[i];
        board.fields[i][1].piece = ChessPiece.PAWN;
        board.fields[i][6].piece = ChessPiece.PAWN;
        board.fields[i][7].piece = order[i];
    }
}

var pieceImages : Record<string, HTMLImageElement> = {};
Object.keys(ChessPiece).forEach(p => {
    Object.keys(PieceColor).forEach(c => {
        var piece = parseInt(p);
        var color = parseInt(c);
        if(!isNaN(piece)&& !isNaN(color)){
            pieceImages[piece+"_"+color] = new Image();
            pieceImages[piece+"_"+color].src = "pieces/"+color+"_"+piece+".svg";
        }
    });
});

var timelineTable : HTMLTableElement;
var timeline = [] as (ChessBoard | null)[][];

var selectedField = null as ChessField | null;
var fieldsToMoveTo = new Set<ChessField>();

function drawBoards(){
    timeline.forEach(time => {
        time.forEach(mul => {
            if(mul!=null)mul.drawBoard();
        });
    });
}

function addBoard(previousBoard: ChessBoard){
    let div : HTMLDivElement;
    let canvas = document.createElement("canvas");
    canvas.classList.add("chessboard");
    let multiverse = 0;
    if(previousBoard.nextBoards.size==0){
        multiverse = previousBoard.multiverse;
    }
    else{
        multiverse = previousBoard.multiverse+1;
        for (const d of timeline) {
            d.splice(multiverse, 0, null);
            for(let f = multiverse;f<d.length;f++){
                if(d[f]!=null){
                    d[f]!.multiverse = f;
                }
            }
        }
    }
    let board = new ChessBoard(canvas, previousBoard, multiverse);
    if(timeline.length<board.time+1){
        let arr = timeline.push([])-1;
        for(let f = 0;f<timeline[0].length;f++){
            timeline[arr].push(null);
        }
    }
    timeline[board.time][board.multiverse] = board;

    let body = timelineTable.createTBody();
    timelineTable.replaceChildren(body);
    for(let m = 0;m<timeline[0].length;m++){
        let row = body.insertRow();
        for(let t = 0;t<timeline.length;t++){
            let cell = row.insertCell();
            if(timeline[t][m]!=null)cell.appendChild(timeline[t][m]!.canvas);
        }
    }
    return board;
}

function main() {
    timelineTable = document.getElementById("timeline") as HTMLTableElement;
    let c = document.getElementById("first-chessboard") as HTMLCanvasElement;
    let f = [] as ChessBoard[];
    f.push(new ChessBoard(c, null, 0));
    timeline.push(f);
    defaultStartBoardFields(f[0]);
    window.onload = e => {drawBoards();};
}

main();